import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import {
  WorkflowCrmActionTestRequest,
  WorkflowCrmActionTestResponse,
  WorkflowConditionTestRequest,
  WorkflowConditionTestResponse,
  WorkflowMutationPreviewRequest,
  WorkflowMutationPreviewResponse
} from '../models/workflow-crm-action.model';

@Injectable({ providedIn: 'root' })
export class WorkflowCrmActionApiService {
  private readonly apiUrl = `${environment.apiUrl}api/workflow-actions`;

  constructor(private http: HttpClient) {}

  test(request: WorkflowCrmActionTestRequest): Observable<WorkflowCrmActionTestResponse> {
    return this.http.post<WorkflowCrmActionTestResponse>(`${this.apiUrl}/crm/test`, request);
  }

  /** Evalúa la condición de un nodo CONDITION contra un registro real, sin inscripción. */
  testCondition(request: WorkflowConditionTestRequest): Observable<WorkflowConditionTestResponse> {
    return this.http.post<WorkflowConditionTestResponse>(`${this.apiUrl}/condition/test`, request);
  }

  previewMutation(request: WorkflowMutationPreviewRequest): Observable<WorkflowMutationPreviewResponse> {
    return this.http.post<WorkflowMutationPreviewResponse>(`${this.apiUrl}/crm/preview-mutation`, request);
  }
}
